// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2h4El","content":"ManualTimeModal_content__1sLaS"};